export { default } from "./CurricUnitDetails";
